import type { CSSProperties } from 'react';
import { clampColumnWidthPx } from '../features/quotations/gridLayout';

/** `width: null` = the flexible column (Item on both tables), which takes what the others leave. */
export interface TableColumn {
  key: string;
  width: number | null;
}

export interface TableLayout {
  /** Each column's width in px; undefined only for a flexible column with no saved width. */
  widths: Record<string, number | undefined>;
  tableStyle: CSSProperties;
}

const MIN_FLEXIBLE_WIDTH_PX = 200;

/**
 * D178: the widths and table style for the columns drawn. Once the flexible column has a saved width
 * the table is the exact sum, so the browser never shares surplus across columns and moves the frozen
 * offsets. Saved keys for a column not drawn are ignored and kept, so it gets its width back.
 */
export function resolveTableLayout(columns: TableColumn[], saved: Record<string, number>): TableLayout {
  const widths: TableLayout['widths'] = {};
  let sum = 0;
  let flexibleOpen = false;
  for (const { key, width } of columns) {
    const px = saved[key] != null ? clampColumnWidthPx(saved[key]) : width;
    if (px == null) flexibleOpen = true;
    widths[key] = px ?? undefined;
    sum += px ?? 0;
  }
  return {
    widths,
    tableStyle: flexibleOpen ? { width: '100%', minWidth: sum + MIN_FLEXIBLE_WIDTH_PX } : { width: sum },
  };
}
